// Copyright 2026 Granite (granite.md). All rights reserved.
// Proprietary and confidential. Unauthorized copying is prohibited.

/** English UI strings: Google Drive references (PLAN.md Phase 11). Merged into the catalog by messages.en.ts. */
export const drive = {
  "settings.section.drive": "Google Drive",
  "drive.title": "Google Drive",
  "drive.description": "Link Drive files into notes. Granite sees only the files you choose.",
  "drive.unavailable": "Google Drive is not set up on this server yet.",
  "drive.connect": "Connect Google Drive",
  "drive.connecting": "Opening Google…",
  "drive.connectedAs": "Connected as {account}.",
  "drive.revoked": "Google no longer accepts this connection (it was removed in your Google account). Connect again to read Drive files.",
  "drive.disconnect": "Disconnect",
  "drive.callback.title": "Connecting Google Drive",
  "drive.callback.working": "Finishing the connection…",
  "drive.callback.failed": "Google Drive was not connected.",
  "drive.callback.back": "Back to settings",
  "drive.callback.toApp": "Going back to the Granite app to finish.",
  "drive.callback.openApp": "Open Granite",
  "drive.insert.title": "Insert from Google Drive",
  "drive.insert.notice": "Everyone who can read this vault can read the files you add, through your Google account ({account}). Granite reads them from Google when asked and keeps no copy.",
  "drive.insert.choose": "Choose files",
  "drive.insert.adding": "Adding…",
  "drive.insert.notConnected": "Connect your Google account first.",
  "drive.panel.empty": "No Drive files in this vault yet. Open a note, then choose Tools › Insert from Google Drive in the left sidebar.",
  "drive.panel.open": "Open in Drive",
  "drive.panel.remove": "Remove {title}",
  "drive.panel.notes": "Linked from",
  "drive.state.trashed": "In Drive's trash",
  "drive.state.no_access": "No access",
  "panels.tab.drive": "Drive",
  "notices.command.insert-drive": "Insert from Google Drive",
  "error.drive_not_connected": "Connect your Google account first.",
  "error.drive_reconnect": "Google no longer accepts the Drive connection. Connect it again in Settings.",
  "error.drive_no_access": "Google Drive no longer gives access to this file.",
  "error.drive_unavailable": "Google Drive did not answer. Try again in a minute.",
  "error.drive_off": "This workspace turned Google Drive off.",
  "error.plan_limit_drive": "Google Drive references need the Pro plan.",
  "error.drive_login_expired": "This Google sign-in expired. Try again.",
} as const;
